import { LitElement, html } from 'lit-element'

import './sbt-map'
import './sbt-map-layer'
import './sbt-map-geojson'
import './sbt-map-popup'

import styles from './sbt-map-wrapper.css'

class SbtMapWrapper extends LitElement {

  static get is() { return 'sbt-map-wrapper' }

  static get styles() { return styles }

  render() {
    return html`

      ${this.zoom && this.center ? html`
        <sbt-map @sbt-map-ready="${this.registerListeners}" .zoomOnScroll="${this.zoomOnScroll}" .zoom="${this.zoom}" .center="${this.center}">
          <slot name="sbtMapWrapperLayers"></slot>
          <slot name="sbtMapWrapperGeoJsons"></slot>
          <slot name="sbtMapWrapperMarkers"></slot>
         
          ${this.popup ? html`
            <sbt-map-popup .coordinates="${this.popup.coordinates}" @sbt-map-popup-closed="${this.onPopupClose}" close-on-outside-click close-button>
              ${this.renderPopupContent()}
            </sbt-map-popup>
          ` : ''}
        </sbt-map>
        ` : html`
        <sbt-map @sbt-map-ready="${this.registerListeners}" .mapBounds="${this.mapBounds}" .zoomOnScroll="${this.zoomOnScroll}">
          <slot name="sbtMapWrapperLayers"></slot>
          <slot name="sbtMapWrapperGeoJsons"></slot>
          <slot name="sbtMapWrapperMarkers"></slot>
         
          ${this.popup ? html`
            <sbt-map-popup .coordinates="${this.popup.coordinates}" @sbt-map-popup-closed="${this.onPopupClose}" close-on-outside-click close-button>
              ${this.renderPopupContent()}
            </sbt-map-popup>
          ` : ''}
        </sbt-map>
        `
      }
      
      ${this.loading ? html `
        <div class="sbt-map__loading">
          <p class="sbt-map__loading-text">
            Loading...    
          </p>
        </div>
      ` : ''}
    `
  }

  get zoomIfAvailable() {
    // return this.zoom ? `.zoom="${this.zoom}"` : ''
  }

  get centerIfAvailable() {
    // return this.center ? `.center="${this.center}"` : ''
  }

  static get properties() {
    return {
      mapBounds: {
        type: Array
      },

      endpointUrl: {
        type: String
      },

      map: {
        type: Object
      },

      popup: {
        type: Object
      },

      zoomOnScroll: {
        type: Boolean
      },

      loading: {
        type: Boolean
      },

      currentFacility: {
        type: Number
      },

      zoom: {
        type: Number
      },

      center: {
        type: Array
      },
    }
  }


  constructor (props) {
    super(props)

    this.center = []
    this.facilityTypes = ['Hotel', 'Pension', 'Apartment', 'House', 'Gästehaus', 'Residencial', 'Ferienhaus', 'Landhaus', 'Landhotel', 'Ecolodge']
    this.islands = ['Azoren', 'Lissabon', 'Kanaren', 'Madeira', 'Kapverden', 'Madeira • Azoren', 'Irland']
    this.loading = true
    this.zoomOnScroll = false
    this.currentFacility = 0
    this.zoom = 0;
    this.center = [];

    // bind 'this' to some of the functions
    this.onFeatureClick = this.onFeatureClick.bind(this)
  }

  /**
   * Register all needed Event Listeners
   */
  registerListeners(event) {
    // Get the map object from the event
    this.map = event.detail

    // Feature
    this.map.on('click', this.onFeatureClick)

    // remove the "Loading..." sign when map completly loaded for the first time
    this.map.once('idle', () => { this.loading = false })
  }

  firstUpdated() {
    this.$ = {}
    this.$.hotelSource = this.shadowRoot.querySelector('#sbt-hotels')
  }

  /**
   * Cluster click
   */
  onClusterClick(event) {
    const selectedCluster = this.map.queryRenderedFeatures(event.point, {layers: ['clusters']})[0] || null
    if (!selectedCluster) {
      return
    }

    const coordinates = SbtMapWrapper.extractCoordinates(selectedCluster, event.lngLat)

    this.map.getSource(selectedCluster.layer.source).getClusterExpansionZoom(selectedCluster.id, (error, expansionZoom) => {
      !error && this.map.zoomTo(expansionZoom, {center: coordinates}, {clusterExpansion: true})
    })
  }

  /**
   * Feature / Hotel / Cluster Click
   */
  onFeatureClick(event) {
    const clickedFeature = this.map.queryRenderedFeatures(event.point)[0]

    if (clickedFeature && clickedFeature.source !== 'composite') {

      // Check if clicked on a cluster
      if (clickedFeature.properties.cluster) {
        this.onClusterClick(event)
        return
      }

      // Check for click outside popup or feature (and close opened popup)
      if (!clickedFeature) {
        this.popup = null;
      }

      // Get needed data for the popup
      const coordinates = SbtMapWrapper.extractCoordinates(clickedFeature, event.lngLat)
      const clickedFeatureData = clickedFeature.properties

      // Create popup with correct data
      setTimeout(() => {
        this.popup = {
          coordinates,
          loading: true,
          item: clickedFeatureData
        }
      })
    }
  }

  /**
   * When a map popup closes we should remove all it's contents
   */
  onPopupClose() {
    this.popup = null
  }

  /**
   * Get the correct coordinates
   * (ex: avoid problems with different coordinate standards,...)
   */
  static extractCoordinates(feature, lngLat) {
    // Ensure that if the map is zoomed out such that multiple
    // copies of the feature are visible, the popup appears
    // over the copy being feature to.
    const coordinates = feature.geometry.coordinates.slice()
    while (Math.abs(lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += lngLat.lng > coordinates[0] ? 360 : -360;
    }
    return coordinates
  }

  /**
   * Simple debounce function
   */
  debounce(fn, time) {
    let timeout;

    return function() {
      const functionCall = () => fn.apply(this, arguments);

      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    }
  }

  /**
   * Render the popup with the correct contents
   * The contents data is on 'this.popup.item'
   */
  renderPopupContent() {
    const popupImage = this.popup.item.image || null
    const popupFacilityType = this.facilityTypes[this.popup.item.facilitytype - 1] || null
    const popupTitle = this.popup.item.title || null
    const popupSubtitle = this.popup.item.subtitle || null
    const popupButtonText = this.popup.item.buttonText || 'Zur Unterkunft'
    const popupSlug = this.popup.item.slug || '/'

    // Create popup with correct content
    return html`
      <a href="${popupSlug}" class="popup" target="_blank" close-button>
        <div class="popup__image-section">
            
          ${popupImage ? html `
            <div class="popup__image-container">
              <img src="${popupImage}" alt="${popupTitle}" class="popup__image">
            </div>
          ` : ''}

        ${popupFacilityType ? html `
          <div class="popup__facility-type">${popupFacilityType}</div>
        ` : ''}
        </div>
        <div class="popup__infos">
          ${popupTitle ? html `
            <h3 class="popup__title">${popupTitle}</h3>
          ` : ''}
          
          ${popupSubtitle ? html `
            <p class="popup__description">${popupSubtitle}</p>
          ` : ''}
        </div>
        
        ${popupButtonText ? html`
          <div class="popup__button-container">
            <button class="popup__button"><span class="popup__button-price">${popupButtonText}</span></button>
          </div>
        ` : ''}
    </a>
    `
  }

}

customElements.define(SbtMapWrapper.is, SbtMapWrapper)
